import React from 'react'
import { Link } from "react-router-dom";


const BlogDetails = () => {
  return (
    <>
      <section className="page_breadcrumb" style={{ background: 'url(assets/img/breadcrumb_bg.webp)' }}>
        <div className="breadcrumb_overlay">
          <div className="container">
            <div className="row">
              <div className="col-12 wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                <div className="breadcrumb_text">
                  <h1>Blog Details</h1>
                  <ul className="d-flex flex-wrap">
                    <li><Link to="/">Home</Link></li>
                    <li><Link to="/">Blog Details</Link></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="blog_details pt_120 xs_pt_100" style={{ marginTop: "-90px" }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12 wow fadeInLeft" style={{ visibility: 'visible', animationName: 'fadeInLeft' }}>
              <div className="blog_details_area">
                <div className="blog_details_img">
                  <img src="assets/img/blog_details_img.webp" alt="blog" className="img-fluid w-100" />
                </div>
                <div className="blog_details_header">
                  <h2>Why Businesses Choose Sewax Services Private Limited as Their Trusted Business Partner</h2>
                </div>
                <div className="blog_details_text">
                  <p>In today's competitive business environment, organizations need more than just individual service providers—they need a trusted partner capable of managing multiple business requirements efficiently. From company registration and website development to facility management, financial consulting, manpower supply, and maintenance services, businesses are increasingly seeking integrated solutions under one roof.</p>
                  <p>Sewax Services Private Limited is committed to delivering comprehensive, reliable, and customer-focused services that help businesses grow, improve efficiency, and achieve long-term success.</p>
                  <h2>One Company, Multiple Professional Services</h2>
                  <p>Managing different vendors for different business needs can be time-consuming and expensive. Sewax Services simplifies this process by offering a wide range of professional services, allowing businesses to focus on their core operations while we handle the rest.</p>
                  <h2>Our major service categories include:</h2>
                  <ul>
                    <li>Property Dealer Services</li>
                    <li> Construction Services</li>
                    <li> Event Management</li>
                    <li>Financial Advisory </li>
                    <li> Solar Energy Solutions</li>
                    <li> Import & Export Services</li>
                    <li> Website Development</li>
                    <li> Company Registration</li>
                    <li> GST & Income Tax Filing</li>
                    <li> Career Employment Support</li>
                    <li> Health & Wellness Products</li>
                    <li> Security Services</li>
                    <li> Housekeeping Services</li>
                    <li> Manpower Supply</li>
                    <li> Facility Management</li>
                    <li> Electrical Services</li>
                    <li> Maintenance & Repair</li>
                    <li> Customer Support Services</li>
                  
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


    </>
  )
}

export default BlogDetails